import React from "react"

const CurveTop = () => (
    <svg width="1920" height="113" viewBox="0 0 1920 113" fill="none" xmlns="http://www.w3.org/2000/svg" className="img-resp">
        <desc>A curve used for design purposes</desc>
        <path d="M1920 0.799995L1813.33 7.0528C1706.67 13.0719 1493.33 25.9281 1280 25.7528C1066.67 25.9281 853.333 13.0719 640 7.0528C426.667 0.799995 213.333 0.799995 106.667 0.799995H0V113H106.667C213.333 113 426.667 113 640 113C853.333 113 1066.67 113 1280 113C1493.33 113 1706.67 113 1813.33 113H1920V0.799995Z" fill="#eff1f6"/>
    </svg>
)

export default CurveTop